import { TranslationAction } from "./translation.action";

/**
 * @deprecated - [fabric-deprecated]
 */
export const translationMessageContext = {
	get: TranslationAction.get.type,
	initialize: TranslationAction.init.type,
};
